export { default, type ExpoHeroSectionRawProps } from './ExpoHeroSection';
